import { render, staticRenderFns } from "./LogisticsDasboard.vue?vue&type=template&id=aea66d78&scoped=true&"
import script from "./LogisticsDasboard.vue?vue&type=script&lang=js&"
export * from "./LogisticsDasboard.vue?vue&type=script&lang=js&"
import style0 from "./LogisticsDasboard.vue?vue&type=style&index=0&id=aea66d78&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aea66d78",
  null
  
)

export default component.exports